export default __webpack_public_path__ + "static/media/cert-english-for-daily-life.bc632b27.png";